module.exports = __webpack_public_path__ + "static/media/1.31fafbe8.png";